module.exports = __webpack_public_path__ + "static/img/app-arc-logo-black@2x.0621f35e.png";